export default __webpack_public_path__ + "static/media/WeD6.bbf9f535.png";